const state = {
  userFBInfo: null,
};
const getters = {
  userFBInfo: state => state.userFBInfo
};
const actions = {
  setUserFBInfo ({state, commit} , user) {
    commit('setUserFBInfo', user)
  },
};
const mutations = {
  setUserFBInfo: (state, user) => state.userFBInfo = user,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js